<script>
import DeleteAccountConfirmation from './DeleteAccountConfirmation.vue'
import DeleteAccountConfirmed from './DeleteAccountConfirmed.vue'
export default {
  name: 'DeleteAccountDialog',
  components: { DeleteAccountConfirmation, DeleteAccountConfirmed },
  data: () => ({
    dialog: false,
    deleted: false
  })
}
</script>
<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="deleted">
    <template #activator="{ on, attrs }">
      <v-btn
        id="deleteAccount"
        v-bind="attrs"
        color="error"
        class="px-8"
        v-on="on">
        {{ $t('button.delete.account') }}
      </v-btn>
    </template>
    <DeleteAccountConfirmed v-if="deleted" />
    <DeleteAccountConfirmation
      v-else
      @confirmed="deleted = true"
      @close="dialog = false"
    />
  </v-dialog>
</template>